export interface PrintContainerLabelDetailsInput {
    containerId: string;
    printerIP: string;
    warehouseId: string;
    associate: string;
    locale?: string;
}

export interface PrintContainerLabelDetailsOutput {
}

export const buildPrintContainerLabelDetailsInput = (containerId: string, printerIP: string,
    warehouseId: string, associate:string, locale: string): PrintContainerLabelDetailsInput => {
    return {
        containerId,
        printerIP,
        warehouseId,
        associate,
        locale
    }

}